<template>
  <div class="index">
    <div class="title">
      用户下单
    </div>
    <div class="box">
      <el-row>
        <el-col :span="6" v-for="item in userBoard" :key="item.type">
          <div class="box-item" @click="toUserOrderPage(item.type)">
            <img class="image" :src="item.icon" alt="">
            <div class="item-content">
              <div class="num">{{ item.num }}</div>
              <div class="name">{{ item.title }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title">
      批量回收
    </div>
    <div class="box">
      <el-row>
        <el-col :span="6" v-for="item in batchBoard" :key="item.type">
          <div class="box-item" @click="toBatchOrderPage(item.type)">
            <img class="image" :src="item.icon" alt="">
            <div class="item-content">
              <div class="num">{{ item.num }}</div>
              <div class="name">{{ item.title }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userBoard: [
        {
          icon: require('../../assets/homeBoard/menu_icon.png'),
          type: 'userOrdersWaitDispatch',
          num: 0,
          title: '待派单'
        }, {
          icon: require('../../assets/homeBoard/menu_icon.png'),
          type: 'userOrdersWithoutAppointment',
          num: 0,
          title: '待预约'
        }, {
          icon: require('../../assets/homeBoard/menu_icon.png'),
          type: 'userOrdersWaitPickUp',
          num: 0,
          title: '待取件'
        }, {
          icon: require('../../assets/homeBoard/menu_icon.png'),
          type: 'userOrdersTimedOut',
          num: 0,
          title: '已超时'
        },
      ],
      batchBoard: [
        {
          icon: require('../../assets/homeBoard/menu_icon.png'),
          type: 'batchRecycleWithoutAppointment',
          num: 0,
          title: '未预约'
        }, {
          icon: require('../../assets/homeBoard/menu_icon.png'),
          type: 'batchRecycleToday',
          num: 0,
          title: '今日订单'
        }, {
          icon: require('../../assets/homeBoard/menu_icon.png'),
          type: 'batchRecycleTodayVisited',
          num: 0,
          title: '今日上门'
        }, {
          icon: require('../../assets/homeBoard/menu_icon.png'),
          type: 'batchRecycleTimedOut',
          num: 0,
          title: '已超时'
        },
      ],
      timeArr: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.HttpService.get(`/autoapp-default-server-recovery/api/tblRecycleOrder/dashboardStatistics`).then(res => {
        if (res.statusCode === 200) {
          let keys = Object.keys(res.data)
          this.userBoard.forEach(item => {
            keys.forEach(data => {
              if (item.type === data) {
                item.num = res.data[data]
              }
            })
          })
          this.batchBoard.forEach(item => {
            keys.forEach(data => {
              if (item.type === data) {
                item.num = res.data[data]
              }
            })
          })
          console.log(res)
        }
      })
    },
    toUserOrderPage(type) {
      let params = {}
      switch (type) {
        case 'userOrdersWaitDispatch':
          // params.activityTimeDataArr = [this.$day(this.$day().format('YYYY-MM-DD 00:00:00')).utc().format(),
          //   this.$day(this.$day().format('YYYY-MM-DD 23:59:59')).utc().format()]
          params.orderState = "-1"
          break
        case 'userOrdersWithoutAppointment':
          // params.expectedVisitTimeDataArr = [this.$day(this.$day().format('YYYY-MM-DD 00:00:00')).utc().format(),
          //   this.$day(this.$day().format('YYYY-MM-DD 23:59:59')).utc().format()]
          params.orderState = "0"
          break
        case 'userOrdersWaitPickUp':
          // params.expectedVisitTimeDataArr = [this.$day(this.$day('1949-10-01').format('YYYY-MM-DD 00:00:00')).utc().format(),
          //   this.$day(this.$day().format('YYYY-MM-DD 00:00:00')).utc().format()]
          params.orderState = "1"
          break
      }
      this.$router.push({
        path: "/order/orderGet",
        query: {
          params: params
        }
      })
    },
    toBatchOrderPage(type) {
      let params = {}
      switch (type) {
        case 'batchRecycleToday':
          params.activityTimeDataArr = [this.$day(this.$day().format('YYYY-MM-DD 00:00:00')).utc().format(),
            this.$day(this.$day().format('YYYY-MM-DD 23:59:59')).utc().format()]
          break;
        case 'batchRecycleTodayVisited':
          params.appointmentTimeDataArr = [this.$day(this.$day().format('YYYY-MM-DD 00:00:00')).utc().format(),
            this.$day(this.$day().format('YYYY-MM-DD 23:59:59')).utc().format()]
          break;
        case 'batchRecycleTimedOut':
          params.appointmentTimeDataArr = [this.$day(this.$day('1949-10-01').format('YYYY-MM-DD 00:00:00')).utc().format(),
            this.$day(this.$day().format('YYYY-MM-DD 23:59:59')).utc().format()];
          params.orderState = '1'
          break

      }
      this.$router.push({
        path: "/order/batchOrderGet",
        query: {
          params: params
        }
      })
    },
  },
}

</script>
<style lang="scss" scoped>
.index {
  background: #FFFFFF;
  margin: 30px 20px;
  padding: 30px 40px;
  height: calc(100vh - 154px);

  .title {
    font-weight: bold;
    font-size: 20px;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      left: -12px;
      height: 20px;
      top: 2px;
      width: 4px;
      background: rgb(113, 147, 248);
    }
  }

  .box {
    margin: 30px 0;

    .box-item {
      display: flex;
      background: #FFFFFF;
      box-shadow: 0 0 14px 0 rgba(0, 0, 0, .1);
      border-radius: 12px;
      margin: 20px 20px;
      padding: 10px;
      cursor: pointer;

      .num {
        font-size: 28px;
        font-weight: bold;
      }

      .item-content {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/homeBoard/index.vue